import {useState,useEffect} from 'react'
import { useCurrent,useFetch, usePut } from '../../../hooks';
import {langObjType,objLangTextHandler,LangArrayToObjKeyValue} from '../../../utils/global'
import { MwButton, MwSpinner } from '../../ui';
import BrandForm from './BrandForm';
import CardHeadeWithActions from '../../ui/CardHeadeWithActions';
import { useTranslation } from 'react-i18next';
import { normalizeApiItem } from '../productUi';

const EditBrand = ({id,setMode}) => {
    const [t] = useTranslation('global')

    const {currentLangList,currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [errors,setErrors] = useState({});
    const [loadingPage,setLoadingPage] = useState(true);

    const {data:dataFetchBrands} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/brands/show/${id}`);
    const {data:resultPut,putData} = usePut();

    const [isActive,setIsActive] = useState(true);
    const [isShowOnWebsite,setIsShowOnWebsite] = useState(false);
    const [brandName,setBrandName] = useState(langObjType());
    const [brandDesc,setBrandDesc] = useState(langObjType());
    const [brandMetaKeywords,setBrandMetaKeywords] = useState(langObjType());

    const formValidate = () => {
        let errorObj = {};
        setErrors({});
        if(!brandName[currentLangId]){
            errorObj = { ...errorObj, [`brandName.${currentLangId}`] :t('product.Brand_name_must_be_entered')};
            setFormLang(currentLangId)
        }

        if(Object.keys(errorObj).length !== 0 ){
            setErrors(errorObj)
            return true
        }
        return false;
    }

    const submitHandler = () => {
        const _data = {
            brandName: objLangTextHandler(brandName),
            brandDesc: objLangTextHandler(brandDesc),
            brandMetaKeywords: objLangTextHandler(brandMetaKeywords),
            isActive,
            isShowOnWebsite,
            tenantId:currentTenantId,
            companyId:currentCompanyId
        }
        
        if(formValidate()) return;
        putData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/brands/update/${id}`,_data);
    }

    useEffect(() =>{
        if(resultPut?.status === 1){
            setMode('List');
        }
    },[resultPut,setMode])

    useEffect(() =>{
        const brandItem = normalizeApiItem(dataFetchBrands);
        if(brandItem){
            setBrandName(LangArrayToObjKeyValue(brandItem.brandName))
            setBrandDesc(LangArrayToObjKeyValue(brandItem.brandDesc))
            setBrandMetaKeywords(LangArrayToObjKeyValue(brandItem.brandMetaKeywords))
            setIsShowOnWebsite(brandItem.isShowOnWebsite)
            setIsActive(brandItem.isActive)
            setLoadingPage(false)
        }
    },[dataFetchBrands]);
    

    return (
        <div className='p-3'>
            { dataFetchBrands && !loadingPage ? <div className='flex flex-col gap-5 px-3 text-sm text-slate-500' >
                    <CardHeadeWithActions title={t('product.updateBrand')} >
                        <MwButton type="cancelBtn" inGroup={true} onClick = {()=>setMode('List')} > {t('product.manageBrands')}  </MwButton>
                        <MwButton type="saveBtn" inGroup={true} onClick={submitHandler} >{t('product.save')}</MwButton>
                    </CardHeadeWithActions>
                    <BrandForm
                        currentLangList={currentLangList}
                        formLang={formLang}
                        setFormLang={setFormLang}
                        errors={errors}
                        brandName={brandName}
                        setBrandName={setBrandName}
                        brandDesc={brandDesc}
                        setBrandDesc={setBrandDesc}
                        brandMetaKeywords={brandMetaKeywords}
                        setBrandMetaKeywords={setBrandMetaKeywords}
                        isShowOnWebsite={isShowOnWebsite}
                        setIsShowOnWebsite={setIsShowOnWebsite}
                        isActive={isActive}
                        setIsActive={setIsActive}
                />
            </div> : <MwSpinner/> }
        </div>
    )

}

export default EditBrand
